import {
  createTranslationResource,
  createTranslationMessages,
} from '@backstage/frontend-plugin-api';
export { sidebarTitlesPtBR } from './sidebarTitles';

import { catalogTranslationRef } from '@backstage/plugin-catalog/alpha';
import { scaffolderTranslationRef } from '@backstage/plugin-scaffolder/alpha';
import { searchReactTranslationRef } from '@backstage/plugin-search-react/alpha';
import { userSettingsTranslationRef } from '@backstage/plugin-user-settings';
import { catalogReactTranslationRef } from '@backstage/plugin-catalog-react/alpha';
import { announcementsTranslationRef } from '@backstage-community/plugin-announcements-react';

// ── Catálogo ──────────────────────────────────────────────────────────────────
export const catalogResource = createTranslationResource({
  ref: catalogTranslationRef,
  translations: {
    'pt-BR': async () => ({
      default: createTranslationMessages({
        ref: catalogTranslationRef,
        messages: {
        'deleteEntity.description': 'Esta entidade não está referenciada por nenhuma localização e não está recebendo atualizações.',
        'deleteEntity.cancelButtonTitle': 'Cancelar',
        'deleteEntity.deleteButtonTitle': 'Excluir',
        'deleteEntity.dialogTitle': 'Tem certeza que deseja excluir esta entidade?',
        'deleteEntity.actionButtonTitle': 'Excluir entidade',
        'indexPage.title': 'Catálogo {{orgName}}',
        'indexPage.createButtonTitle': 'Criar',
        'indexPage.supportButtonContent': 'Todas as entidades do catálogo de software',
        'entityPage.notFoundMessage': 'Não há nenhum {{kind}} com o {{link}} solicitado.',
        'entityPage.notFoundLinkText': 'tipo, namespace e nome',
        'aboutCard.title': 'Sobre',
        'aboutCard.unknown': 'desconhecido',
        'aboutCard.refreshButtonTitle': 'Agendar atualização da entidade',
        'aboutCard.editButtonTitle': 'Editar Metadados',
        'aboutCard.editButtonAriaLabel': 'Editar',
        'aboutCard.createSimilarButtonTitle': 'Criar algo similar',
        'aboutCard.refreshScheduledMessage': 'Atualização agendada',
        'aboutCard.refreshButtonAriaLabel': 'Atualizar',
        'aboutCard.launchTemplate': 'Iniciar Template',
        'aboutCard.viewTechdocs': 'Ver TechDocs',
        'aboutCard.viewSource': 'Ver Código-fonte',
        'aboutCard.descriptionField.value': 'Sem descrição',
        'aboutCard.descriptionField.label': 'Descrição',
        'aboutCard.ownerField.value': 'Sem Responsável',
        'aboutCard.ownerField.label': 'Responsável',
        'aboutCard.domainField.value': 'Sem Domínio',
        'aboutCard.domainField.label': 'Domínio',
        'aboutCard.systemField.value': 'Sem Sistema',
        'aboutCard.systemField.label': 'Sistema',
        'aboutCard.parentComponentField.value': 'Sem Componente Pai',
        'aboutCard.parentComponentField.label': 'Componente Pai',
        'aboutCard.kindField.label': 'Tipo',
        'aboutCard.typeField.label': 'Categoria',
        'aboutCard.lifecycleField.label': 'Ciclo de Vida',
        'aboutCard.tagsField.value': 'Sem Tags',
        'aboutCard.tagsField.label': 'Tags',
        'aboutCard.targetsField.label': 'Alvos',
        'searchResultItem.type': 'Tipo',
        'searchResultItem.kind': 'Categoria',
        'searchResultItem.owner': 'Responsável',
        'searchResultItem.lifecycle': 'Ciclo de Vida',
        'catalogTable.allFilters': 'Todos',
        'catalogTable.warningPanelTitle': 'Não foi possível carregar as entidades do catálogo.',
        'catalogTable.viewActionTitle': 'Visualizar',
        'catalogTable.editActionTitle': 'Editar',
        'catalogTable.starActionTitle': 'Adicionar aos favoritos',
        'catalogTable.unStarActionTitle': 'Remover dos favoritos',
        'dependencyOfComponentsCard.title': 'Dependência de componentes',
        'dependencyOfComponentsCard.emptyMessage': 'Nenhum componente depende deste componente.',
        'dependsOnComponentsCard.title': 'Depende de componentes',
        'dependsOnComponentsCard.emptyMessage': 'Nenhum componente é dependência deste componente.',
        'dependsOnResourcesCard.title': 'Depende de recursos',
        'dependsOnResourcesCard.emptyMessage': 'Nenhum recurso é dependência deste componente.',
        'entityContextMenu.copiedMessage': 'Copiado!',
        'entityContextMenu.moreButtonTitle': 'Mais',
        'entityContextMenu.inspectMenuTitle': 'Inspecionar entidade',
        'entityContextMenu.copyURLMenuTitle': 'Copiar URL da entidade',
        'entityContextMenu.unregisterMenuTitle': 'Cancelar registro da entidade',
        'entityContextMenu.moreButtonAriaLabel': 'mais',
        'entityLabelsCard.title': 'Rótulos',
        'entityLabelsCard.columnKeyLabel': 'Rótulo',
        'entityLabelsCard.columnValueLabel': 'Valor',
        'entityLabels.ownerLabel': 'Responsável',
        'entityLabels.lifecycleLabel': 'Ciclo de Vida',
        'entityLinksCard.title': 'Links',
        'entityNotFound.title': 'Entidade não encontrada',
        'entityNotFound.docButtonTitle': 'DOCS',
        'entityTabs.tabsAriaLabel': 'Abas',
        'hasComponentsCard.title': 'Possui componentes',
        'hasComponentsCard.emptyMessage': 'Nenhum componente faz parte deste sistema.',
        'hasResourcesCard.title': 'Possui recursos',
        'hasResourcesCard.emptyMessage': 'Nenhum recurso faz parte deste sistema.',
        'hasSubcomponentsCard.title': 'Possui subcomponentes',
        'hasSubcomponentsCard.emptyMessage': 'Nenhum subcomponente faz parte deste componente.',
        'hasSubdomainsCard.title': 'Possui subdomínios',
        'hasSubdomainsCard.emptyMessage': 'Nenhum subdomínio faz parte deste domínio.',
        'hasSystemsCard.title': 'Possui sistemas',
        'hasSystemsCard.emptyMessage': 'Nenhum sistema faz parte deste domínio.',
        'systemDiagramCard.title': 'Diagrama do Sistema',
        'systemDiagramCard.description': 'Use pinça e zoom para navegar pelo diagrama.',
        'systemDiagramCard.edgeLabels.partOf': 'parte de',
        'systemDiagramCard.edgeLabels.dependsOn': 'depende de',
        'systemDiagramCard.edgeLabels.provides': 'fornece',
        },
      }),
    }),
  },
});

// ── Catálogo React ─────────────────────────────────────────────────────────────
export const catalogReactResource = createTranslationResource({
  ref: catalogReactTranslationRef,
  translations: {
    'pt-BR': async () => ({
      default: createTranslationMessages({
        ref: catalogReactTranslationRef,
        messages: {
        'catalogFilter.title': 'Filtros',
        'catalogFilter.buttonTitle': 'Filtros',
        'entityKindPicker.title': 'Tipo',
        'entityKindPicker.errorMessage': 'Falha ao carregar tipos de entidade',
        'entityLifecyclePicker.title': 'Ciclo de Vida',
        'entityNamespacePicker.title': 'Namespace',
        'entityOwnerPicker.title': 'Responsável',
        'entityProcessingStatusPicker.title': 'Status de Processamento',
        'entityTagPicker.title': 'Tags',
        'entitySearchBar.placeholder': 'Buscar',
        'entityTypePicker.title': 'Categoria',
        'entityTypePicker.errorMessage': 'Falha ao carregar categorias',
        'entityTypePicker.optionAllTitle': 'todos',
        'favoriteEntity.addToFavorites': 'Adicionar aos favoritos',
        'favoriteEntity.removeFromFavorites': 'Remover dos favoritos',
        'inspectEntityDialog.title': 'Inspetor de Entidade',
        'inspectEntityDialog.closeButtonTitle': 'Fechar',
        'inspectEntityDialog.tabNames.json': 'JSON Bruto',
        'inspectEntityDialog.tabNames.yaml': 'YAML Bruto',
        'inspectEntityDialog.tabNames.overview': 'Visão Geral',
        'inspectEntityDialog.tabNames.ancestry': 'Ancestralidade',
        'inspectEntityDialog.tabNames.colocated': 'Colocalizados',
        'unregisterEntityDialog.title': 'Tem certeza que deseja cancelar o registro desta entidade?',
        'unregisterEntityDialog.cancelButtonTitle': 'Cancelar',
        'unregisterEntityDialog.deleteButtonTitle': 'Excluir Entidade',
        'unregisterEntityDialog.deleteEntitySuccessMessage': 'Entidade {{entityName}} removida',
        'unregisterEntityDialog.unregisterState.unregisterButtonTitle': 'Cancelar Registro do Local',
        'userListPicker.defaultOrgName': 'Empresa',
        'userListPicker.orgFilterAllLabel': 'Todos',
        'userListPicker.personalFilter.title': 'Pessoal',
        'userListPicker.personalFilter.ownedLabel': 'De minha autoria',
        'userListPicker.personalFilter.starredLabel': 'Favoritos',
        'entityTableColumnTitle.name': 'Nome',
        'entityTableColumnTitle.type': 'Tipo',
        'entityTableColumnTitle.title': 'Título',
        'entityTableColumnTitle.description': 'Descrição',
        'entityTableColumnTitle.system': 'Sistema',
        'entityTableColumnTitle.namespace': 'Namespace',
        'entityTableColumnTitle.tags': 'Tags',
        'entityTableColumnTitle.domain': 'Domínio',
        'entityTableColumnTitle.owner': 'Responsável',
        'entityTableColumnTitle.lifecycle': 'Ciclo de Vida',
        'missingAnnotationEmptyState.title': 'Anotação Ausente',
        'missingAnnotationEmptyState.readMore': 'Leia mais',
        },
      }),
    }),
  },
});

// ── Scaffolder ────────────────────────────────────────────────────────────────
export const scaffolderResource = createTranslationResource({
  ref: scaffolderTranslationRef,
  translations: {
    'pt-BR': async () => ({
      default: createTranslationMessages({
        ref: scaffolderTranslationRef,
        messages: {
        'templateListPage.title': 'Criar novo componente',
        'templateListPage.subtitle': 'Crie novos componentes de software usando templates padronizados da sua organização',
        'templateListPage.pageTitle': 'Criar novo componente',
        'templateListPage.templateGroups.defaultTitle': 'Templates',
        'templateListPage.templateGroups.otherTitle': 'Outros Templates',
        'templateListPage.contentHeader.registerExistingButtonTitle': 'Registrar Componente Existente',
        'templateWizardPage.title': 'Criar novo componente',
        'templateWizardPage.subtitle': 'Crie novos componentes de software usando templates padronizados da sua organização',
        'templateWizardPage.templateWithTitle': 'Criar {{templateTitle}}',
        'listTaskPage.title': 'Listar tarefas de templates',
        'listTaskPage.subtitle': 'Todas as tarefas que foram iniciadas',
        'listTaskPage.content.tableCell.template': 'Template',
        'listTaskPage.content.tableCell.status': 'Status',
        'listTaskPage.content.tableCell.owner': 'Responsável',
        'listTaskPage.content.tableCell.created': 'Criado em',
        'listTaskPage.content.tableCell.taskID': 'ID da Tarefa',
        'listTaskPage.content.tableTitle': 'Tarefas',
        'ownerListPicker.options.all': 'Todos',
        'ownerListPicker.options.owned': 'De minha autoria',
        'ongoingTask.contextMenu.cancel': 'Cancelar',
        'ongoingTask.contextMenu.retry': 'Tentar novamente',
        'ongoingTask.contextMenu.startOver': 'Recomeçar',
        'ongoingTask.contextMenu.hideLogs': 'Ocultar Logs',
        'ongoingTask.contextMenu.showLogs': 'Exibir Logs',
        'ongoingTask.cancelButtonTitle': 'Cancelar',
        'ongoingTask.retryButtonTitle': 'Tentar novamente',
        'ongoingTask.startOverButtonTitle': 'Recomeçar',
        'actionsPage.title': 'Ações instaladas',
        'actionsPage.content.searchFieldPlaceholder': 'Buscar uma ação',
        'fields.entityNamePicker.title': 'Nome',
        'fields.entityNamePicker.description': 'Nome único do componente',
        'fields.ownerPicker.title': 'Responsável',
        'fields.ownerPicker.description': 'O responsável pelo componente',
        },
      }),
    }),
  },
});

// ── Busca ─────────────────────────────────────────────────────────────────────
export const searchResource = createTranslationResource({
  ref: searchReactTranslationRef,
  translations: {
    'pt-BR': async () => ({
      default: {
        'searchBar.title': 'Buscar',
        'searchBar.placeholder': 'Buscar em {{org}}',
        'searchBar.clearButtonTitle': 'Limpar',
        'searchFilter.allOptionTitle': 'Todos',
        'searchPagination.limitLabel': 'Resultados por página:',
        'searchPagination.limitText': 'de {{num}}',
        'noResultsDescription': 'Desculpe, nenhum resultado encontrado',
        'searchResultGroup.linkTitle': 'Ver Todos',
        'searchResultGroup.addFilterButtonTitle': 'Adicionar filtro',
        'searchResultPager.next': 'Próximo',
        'searchResultPager.previous': 'Anterior',
      },
    }),
  },
});

// ── Configurações do Usuário ───────────────────────────────────────────────────
export const userSettingsResource = createTranslationResource({
  ref: userSettingsTranslationRef,
  translations: {
    'pt-BR': async () => ({
      default: createTranslationMessages({
        ref: userSettingsTranslationRef,
        messages: {
        'featureFlags.title': 'Feature Flags',
        'featureFlags.description': 'Recarregue a página ao alternar feature flags',
        'featureFlags.filterTitle': 'Filtrar',
        'featureFlags.clearFilter': 'Limpar filtro',
        'featureFlags.emptyFlags.title': 'Nenhuma Feature Flag',
        'featureFlags.flagItem.title.disable': 'Desativar',
        'featureFlags.flagItem.title.enable': 'Ativar',
        'featureFlags.flagItem.subtitle.registeredInApplication': 'Registrado na aplicação',
        'featureFlags.flagItem.subtitle.registeredInPlugin': 'Registrado no plugin {{pluginId}}',
        'languageToggle.title': 'Idioma',
        'languageToggle.description': 'Alterar o idioma',
        'themeToggle.title': 'Tema',
        'themeToggle.description': 'Alterar o tema',
        'themeToggle.names.auto': 'Automático',
        'themeToggle.names.dark': 'Escuro',
        'themeToggle.names.light': 'Claro',
        'signOutMenu.title': 'Sair',
        'pinToggle.title': 'Fixar Barra Lateral',
        'pinToggle.description': 'Impedir que a barra lateral seja recolhida',
        'pinToggle.switchTitles.unpin': 'Desafixar Barra Lateral',
        'pinToggle.switchTitles.pin': 'Fixar Barra Lateral',
        'identityCard.title': 'Identidade Backstage',
        'identityCard.noIdentityTitle': 'Sem Identidade Backstage',
        'identityCard.userEntity': 'Entidade do Usuário',
        'identityCard.ownershipEntities': 'Entidades de Responsabilidade',
        'authProviders.title': 'Provedores Disponíveis',
        'emptyProviders.title': 'Sem Provedores de Autenticação',
        'providerSettingsItem.buttonTitle.signOut': 'Sair',
        'providerSettingsItem.buttonTitle.signIn': 'Entrar',
        'defaultSettingsPage.tabsTitle.featureFlags': 'Feature Flags',
        'defaultSettingsPage.tabsTitle.authProviders': 'Provedores de Autenticação',
        'defaultSettingsPage.tabsTitle.general': 'Geral',
        'settingsLayout.title': 'Configurações',
        'sidebarTitle': 'Configurações',
        'profileCard.title': 'Perfil',
        'appearanceCard.title': 'Aparência',
        },
      }),
    }),
  },
});

// ── Anúncios ──────────────────────────────────────────────────────────────────
export const announcementsResource = createTranslationResource({
  ref: announcementsTranslationRef,
  translations: {
    'pt-BR': async () => ({
      default: createTranslationMessages({
        ref: announcementsTranslationRef,
        messages: {
        'admin.adminPortal.title': 'Portal de Administração de Anúncios',
        'admin.adminPortal.subtitle': 'Gerencie anúncios e categorias',
        'admin.adminPortal.announcementsLabels': 'Anúncios',
        'admin.adminPortal.categoriesLabel': 'Categorias',
        'admin.announcementsContent.table.active': 'Ativo',
        'admin.announcementsContent.table.inactive': 'Inativo',
        'admin.announcementsContent.table.body': 'Corpo',
        'admin.announcementsContent.table.title': 'Título',
        'admin.announcementsContent.table.status': 'Status',
        'admin.announcementsContent.table.actions': 'Ações',
        'admin.announcementsContent.table.category': 'Categoria',
        'admin.announcementsContent.table.publisher': 'Publicador',
        'admin.announcementsContent.announcements': 'Anúncios',
        'admin.announcementsContent.alertMessage': 'Anúncio criado.',
        'admin.announcementsContent.alertMessageWithNewCategory': 'com nova categoria',
        'admin.announcementsContent.cancelButton': 'Cancelar',
        'admin.announcementsContent.createButton': 'Criar Anúncio',
        'admin.announcementsContent.noAnnouncementsFound': 'Nenhum anúncio encontrado',
        'admin.categoriesContent.table.title': 'Título',
        'admin.categoriesContent.table.actions': 'Ações',
        'admin.categoriesContent.table.categoryDeleted': 'Categoria excluída.',
        'admin.categoriesContent.table.slug': 'Slug',
        'admin.categoriesContent.table.addTooltip': 'Adicionar',
        'admin.categoriesContent.table.noCategoriesFound': 'Nenhuma categoria encontrada.',
        'admin.categoriesContent.createdMessage': 'criada',
        'admin.categoriesContent.cancelButton': 'Cancelar',
        'admin.categoriesContent.createButton': 'Criar categoria',
        'admin.categoriesContent.deletedMessage': 'Categoria excluída.',
        'announcementForm.active': 'Ativo',
        'announcementForm.title': 'Título',
        'announcementForm.submit': 'Enviar',
        'announcementForm.excerpt': 'Resumo',
        'announcementForm.editAnnouncement': 'Editar anúncio',
        'announcementForm.newAnnouncement': 'Novo anúncio',
        'announcementForm.categoryInput.label': 'Categoria',
        'announcementForm.categoryInput.create': 'Criar',
        'announcementsPage.grid.announcementDeleted': 'Anúncio excluído.',
        'announcementsPage.contextMenu.admin': 'Admin',
        'announcementsPage.contextMenu.categories': 'Categorias',
        'announcementsPage.newAnnouncement': 'Novo anúncio',
        'announcementsPage.genericNew': 'Novo',
        'announcementsPage.card.by': 'Por',
        'announcementsPage.card.in': 'em',
        'announcementsPage.card.delete': 'EXCLUIR',
        'announcementsPage.card.edit': 'EDITAR',
        'deleteDialog.cancel': 'Cancelar',
        'deleteDialog.title': 'Tem certeza que deseja excluir este anúncio?',
        'deleteDialog.delete': 'Excluir',
        'announcementsCard.new': 'Novo',
        'announcementsCard.in': 'em',
        'announcementsCard.announcements': 'Anúncios',
        'announcementsCard.seeAll': 'Ver todos',
        'announcementsCard.noAnnouncements': 'Ainda não há anúncios, quer',
        'announcementsCard.addOne': 'adicionar um',
        'announcementSearchResultListItem.published': 'Publicado',
        'announcementSearchResultListItem.announcement': 'Anúncio',
        'announcementsTimeline.error': 'Erro',
        'announcementsTimeline.noAnnouncements': 'Sem anúncios',
        'categoriesForm.submit': 'Enviar',
        'categoriesForm.newCategory': 'Nova categoria',
        },
      }),
    }),
  },
});
